import q from 'query-string'
import fetch from 'isomorphic-fetch'
import env from '../env';

// tfabconnect API
// APIとほぼ一対一対応する
// see also: https://bitbucket.org/syunpouen/tfabconiot-hub

const toJson = (res) => {
    if(!res.ok)
        return res.text()
        .then(txt => {
          return Promise.reject(new Error(txt))
        })
    return res.json()
}
const toText = (res) => {
    if(!res.ok)
      return res.text()
      .then(txt => Promise.reject(new Error(txt)))
    return res.text()
}

export class rawAPI {
  constructor() {
    this.endpoint = env.API_BASEPATH
  }

  _fetchWithTimeout(url, opts, waittime) {
    // fetch (というかPromise)にtimeoutがない問題
    // see also: https://davidwalsh.name/fetch-timeout
    // see also: https://blog.jxck.io/entries/2017-07-19/aborting-fetch.html 今後に期待
    return new Promise(function(resolve, reject) {
      let didTimeOut = false
      const timeout = setTimeout(function() {
          didTimeOut = true
          reject(new Error('Request timed out'));
      }, waittime);

      return fetch(url, opts)
        .then((response) => {
          clearTimeout(timeout);
          if(!didTimeOut) {
              resolve(response);
          }
      })
        .catch(function(err) {
          console.warn('fetch failed! ', err);
          if(didTimeOut) return;
          reject(err);
      });
    })
  }

  get(path, query, headers={}) {
    let url = `${this.endpoint}${path}`
    if (query && Object.keys(query).length > 0) {
      url += `?${q.stringify(query)}`
    }
    const header = new Headers()
    if (headers) {
      Object.keys(headers).forEach(key => {
        header.append(key, headers[key])
      })
    }
    const opts = {
      method: 'GET',
      headers: header,
    }
    console.debug(`GET: ${url}`)
    return this._fetchWithTimeout(url, opts, 5000)
  }

  post(path, query, body, headers) {
    const url = `${this.endpoint}${path}` + ((query)? `?${q.stringify(query)}`: "")
    const header = new Headers()
    header.append("Content-Type", "application/json")
    if (headers) {
      Object.keys(headers).forEach(key => {
        header.append(key, headers[key])
      })
    }
    const opts = {
      method: 'POST',
      headers: header,
      body: (body)? JSON.stringify(body) : undefined
    }
    console.debug(`POST: ${url}`)
    console.debug(`POST: ` + JSON.stringify(body))
    return this._fetchWithTimeout(url, opts, 5000)
  }

  put(path, query, body, headers) {
    const url = `${this.endpoint}${path}` + ((query)? `?${q.stringify(query)}`: "")
    const header = new Headers()
    header.append("Content-Type", "application/json")
    if (headers) {
      Object.keys(headers).forEach(key => {
        header.append(key, headers[key])
      })
    }
    const opts = {
      method: 'PUT',
      headers: header,
      body: (body)? JSON.stringify(body) : undefined
    }
    console.debug(`PUT: ${url}`)
    console.debug(`PUT: ` + JSON.stringify(opts.headers))
    return this._fetchWithTimeout(url, opts, 5000)
  }

  delete(path, headers) {
    let url = `${this.endpoint}${path}`
    const header = new Headers()
    if (headers) {
      Object.keys(headers).forEach(key => {
        header.append(key, headers[key])
      })
    }
    const opts = {
      method: 'DELETE',
      headers: header,
    }
    console.debug(`DELETE: ${url}`)
    return this._fetchWithTimeout(url, opts, 5000)
  }

  // User系API
  authorization(code, userToken=undefined) {
    const query = {
      code: code
    }
    let header = {}
    if (process.env.NODE_ENV === "development") {
      header = {"DEBUG-WEBUI-DEVELOPMENT": process.env.VUE_APP_AUTH_REDIRECT_URL}
    }
    if (userToken) {
      header["Authorization"] = `Bearer ${userToken}`
    }
    return this.post(`/authorization`, query, null, header)
    .then(toJson)
  }

  registerUser(appId="tfab-beta") {
    const body = {AppID: appId}
    return this.post("/users", null, body)
    .then(toJson)
  }

  getUser(userToken) {
    return this.get(`/users`, null, {'Authorization': `Bearer ${userToken}`})
    .then(toJson)
  }

  modifyUser(name, userToken) {
    return this.put('/users', null, { Name: name }, {'Authorization': `Bearer ${userToken}`})
    .then(toText)
  }

  deleteUser(userToken) {
    return this.delete('/users', {'Authorization': `Bearer ${userToken}`})
    .then(toText)
  }

  // Group系API
  registerGroup(name, userToken) {
    return this.post('/groups', null, { Name: name }, {'Authorization': `Bearer ${userToken}`})
    .then(toJson)
  }

  getGroup(gToken) {
    return this.get(`/groups`, null, {'Authorization': `Bearer ${gToken}`})
    .then(toJson)
  }

  renameGroup(gId, name, userToken) {
    return this.put(`/groups/${gId}`, null, { Name: name }, {'Authorization': `Bearer ${userToken}`})
    .then(toText)
  }

  restateGroup(gId, state, userToken) {
    return this.put(`/groups/${gId}/share/${state}`, null, { Name: name }, {'Authorization': `Bearer ${userToken}`})
    .then(toText)
  }

  deleteGroup(groupId, userToken) { // グループを削除する
    return this.delete(`/groups/${groupId}`, {'Authorization': `Bearer ${userToken}`})
    .then(toText)
  }

  leaveGroup(groupId, userToken) {  // グループから脱退する
    return this.delete(`/groups/${groupId}/members`, {'Authorization': `Bearer ${userToken}`})
    .then(toText)
  }

  // eslint-disable-next-line no-unused-vars
  banishFromGroup(groupId, userId, userToken) { // ユーザーを追放する
    return this.delete(`/groups/${groupId}/members/${userId}`, {'Authorization': `Bearer ${userToken}`})
    .then(toText)
  }

  // クラウド変数系API
  registerVariable(name, gId, groupToken) {
    const body = {Name: name, GroupID: gId}
    return this.post("/variables", null, body, {'Authorization': `Bearer ${groupToken}`})
    .then(toJson)
  }

  getVariable(vId, vToken) {
    if (vToken == null) {
      return this.get(`/variables/${vId}`, null)
        .then(toJson)
    } else {
      return this.get(`/variables/${vId}`, null, { 'Authorization': `Bearer ${vToken}` })
        .then(toJson)
    }
  }

// eslint-disable-next-line no-unused-vars
  modifyVariable(vId, token) {
    // Not implemented.
  }

  deleteVariable(vId, vToken) {
    return this.delete(`/variables/${vId}`, {'Authorization': `Bearer ${vToken}`})
    .then(toText)
  }

  // データ系API
  // eslint-disable-next-line no-unused-vars
  sendData(value, vType, vToken) {
    // value type is not implemented.
    const body = {Value: value, ValueType: "string"}
    return this.post(`/data`, null, body, {'Authorization': `Bearer ${vToken}`})
    .then(toText)
  }

  getData(vId, limit, vToken, since, until) {
    // query: {limit: number, since: YYYY-MM-DD, until: YYYY-MM-DD}
    const query = {
      limit: limit
    }
    if (since)
      query.since = since.valueOf()
    if (until)
      query.until = until.valueOf()
    if (vToken == null) {
      query.state = "public"
      return this.get(`/data/${vId}`, query)
      .then(toJson)
    } else {
      return this.get(`/data/${vId}`, query, { 'Authorization': `Bearer ${vToken}` })
      .then(toJson)
    }
  }

  // 認証系API
  getUserToken(id, refreshToken) {
    const body = {
      scope: 'user',
      TargetID: id
    }
    return this.post('/token', null, body, {'Authorization': `Bearer ${refreshToken}`})
    .then(toJson)
  }

  getGroupToken(id, refreshToken) {
    const body = {
      scope: 'group',
      TargetID: id
    }
    return this.post("/token", null, body, {'Authorization': `Bearer ${refreshToken}`})
    .then(toJson)
  }

  getVariableToken(id, refreshToken) {
    const body = {
      scope: 'variable',
      TargetID: id
    }
    return this.post('/token', null, body, {'Authorization': `Bearer ${refreshToken}`})
    .then(toJson)
  }

  // 招待系API
  inviteGroup(groupToken) {
    return this.post('/groupconnections', null, null, {'Authorization': `Bearer ${groupToken}`})
    .then(toJson)
  }

  joinGroup(connectionId, userToken) {
    return this.post(`/groupconnections/${connectionId}`, null, null, {'Authorization': `Bearer ${userToken}`})
    .then(toText)
  }

  // Coupon系API
  showCoupons(userToken) {
    return this.get('/coupons', null, { 'Authorization': `Bearer ${userToken}` })
      .then(toJson)
  }

  showCoupon(userToken, couponId) {
    return this.get(`/coupons/${couponId}`, null, { 'Authorization': `Bearer ${userToken}` })
      .then(toJson)
  }

  getCoupon(userToken) {
    return this.get('/coupon/my', null, {'Authorization': `Bearer ${userToken}`})
    .then(toJson)
  }

  registerCoupon(userToken, code, force) {
    const body = { Code: code }
    return this.post(`/coupon/my?force=${force}`, null, body, {'Authorization': `Bearer ${userToken}`})
    .then(toText)
  }

  deleteCoupon(userToken) {
    return this.delete('/coupon/my', {'Authorization': `Bearer ${userToken}`})
    .then(toText)
  }

  now() {
    return this.get('/now', null)
    .then(res => res.json())
    .then(res => {
      return res.Timestamp
    })
  }
}

export default function raw() {
  return new rawAPI()
}
